import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FileText, X, Search, Info } from "lucide-react";
import { toast } from "react-toastify";


const TakaDetailModal = ({
  show,
  onHide,
  onComplete,
  takaSearch,
  setTakaSearch,
  selectedTakas,
  setSelectedTakas,
  takaQty,
  setTakaQty,
  themeColors,
  Details,
  selectedIds,
  SubMianDetails,
  initialIssueMeterValues,
  TransFiltersdata,
  currentTransTypeId,
  AppSetupDetaildata,
  onIssueMeterEditableChange,


}) => {
  const {
    iscolour,
    iscolourDark,
    isdark,
    headingCol,
    accentCol
  } = themeColors;

  console.log(Details);
  console.log(Details);


  const [issueMeterValues, setIssueMeterValues] = React.useState({});

  const [shortStage, setShortStage] = React.useState("0.00");
  const [headerTaka, setHeaderTaka] = React.useState("0");
  const [greyMtrs, setGreyMtrs] = React.useState("0.00");
  const [location, setLocation] = React.useState("");

  const [searchF6, setSearchF6] = useState("");
  const [issueTaka, setIssueTaka] = useState(0);
  const [takaMeter, setTakaMeter] = useState(0.00);

  React.useEffect(() => {
    if (!show) return;

    setIssueMeterValues(
      initialIssueMeterValues || {}
    );
  }, [show, initialIssueMeterValues]);


  React.useEffect(() => {
    if (!show) {
      setIssueMeterValues({});
      setSelectedTakas({});
      setTakaQty("");
      setTakaSearch("");
    }
  }, [
    show,
    setSelectedTakas,
    setTakaQty,
    setTakaSearch
  ]);

  useEffect(() => {
    const selectedRows = (SubMianDetails || []).filter((row, index) => {
      const rowId = `${row?.TransDtlID ?? "row"}_${index}`;
      return !!selectedTakas?.[rowId];
    });

    // Selected Taka ki count
    const takaCount = selectedRows.length;

    // Selected Taka ke Issue Meter ka total
    const totalMeter = selectedRows.reduce((total, row, index) => {
      const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

      return total + Number(issueMeterValues?.[rowId] || 0);
    }, 0);

    setIssueTaka(takaCount);
    setTakaMeter(totalMeter);
  }, [selectedTakas, issueMeterValues, SubMianDetails]);


  const detailList = Array.isArray(Details)
    ? Details
    : [];

  const appSetupDtl = Array.isArray(AppSetupDetaildata?.AppSetupDtl)
    ? AppSetupDetaildata.AppSetupDtl
    : [];


  const isIssueMeterEditable =
    appSetupDtl.some(
      item =>
        Number(item?.ShortageTransTypeId) ===
        Number(currentTransTypeId)
    ) &&
    TransFiltersdata?.TransSetup[0]?.DisableQtyChange === false;

  const isIssueMeterEditbutton =
    appSetupDtl.some(
      item =>
        Number(item?.ShortageTransTypeId) ===
        Number(currentTransTypeId)
    )

  useEffect(() => {
    onIssueMeterEditableChange?.(isIssueMeterEditbutton);
  }, [isIssueMeterEditbutton, onIssueMeterEditableChange]);





  const subMainDetailList = Array.isArray(SubMianDetails)
    ? SubMianDetails
    : [];


  const selectedIdArray = Array.isArray(selectedIds)
    ? selectedIds
    : [selectedIds];

  const transSetup = TransFiltersdata?.TransSetup?.[0] || {};

  const showShortage = transSetup?.IsShortageCalcReq === true;

  const showGreyMtr = transSetup?.IsQtySelReq === true;

  const showLocation = transSetup?.LotLocationInput === true;

  const showTaka = transSetup?.IsTakaSelect === true;

  const showShortageColumns =
    transSetup?.FlagShortageHappen === true;

  const isAutoShortage =
    transSetup?.FlagAutoShortage === true;





  /* =========================
     INFO CARDS → Details
     ========================= */

  const matchedInfoDetails = detailList.filter((item) =>
    selectedIdArray.some(
      (id) =>
        String(id) === String(item?.InwCode)
    )
  );

  /* =========================
     TABLE → SubMianDetails
     ========================= */

  const matchedTableDetails = subMainDetailList.filter((item) =>
    selectedIdArray.some(
      (id) =>
        String(id) === String(item?.InwCode)
    )
  );

  console.log(matchedTableDetails);


  const calculateIssueMeterByShortage = (balanceMeter, shortagePercent) => {
    const balance = Number(balanceMeter || 0);
    const percent = Number(shortagePercent || 0);

    if (balance <= 0) return 0;

    const shortMeter = (balance * percent) / 100;

    return Math.max(balance - shortMeter, 0);
  };

  const handleHeaderTakaEnter = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const qty = Number(headerTaka || 0);

    // Pehle existing selection clear
    if (qty <= 0) {
      setSelectedTakas({});
      setIssueMeterValues({});
      return;
    }

    // Jitne Taka available hain, utne hi select honge
    const rowsToSelect = matchedTableDetails.slice(0, qty);

    const newSelectedTakas = {};
    const newIssueMeterValues = {};

    rowsToSelect.forEach((row, index) => {
      const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

      newSelectedTakas[rowId] = true;

      // Shortage % ke according Issue Meter calculate
      const balanceMeter = Number(row?.BalMeter ?? 0);

      const issueMeter = calculateIssueMeterByShortage(
        balanceMeter,
        shortStage
      );

      newIssueMeterValues[rowId] = issueMeter.toFixed(2);
    });

    setSelectedTakas(newSelectedTakas);
    setIssueMeterValues(newIssueMeterValues);

    // Actual selected Taka count header me rakho
    setHeaderTaka(String(rowsToSelect.length));
  };

  const handleGreyMtrsEnter = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const enteredMeter = Number(greyMtrs);
    const shortagePercent = Number(shortStage || 0);

    // ==============================
    // VALIDATION
    // ==============================

    if (greyMtrs === "" || greyMtrs == null) {
      alert("Please enter Grey Mtrs");
      return;
    }

    if (!Number.isFinite(enteredMeter) || enteredMeter <= 0) {
      alert("Grey Mtrs must be greater than 0");
      return;
    }

    if (
      !Number.isFinite(shortagePercent) ||
      shortagePercent < 0 ||
      shortagePercent > 100
    ) {
      alert("Please enter valid Shortage (%)");
      return;
    }

    // ==============================
    // FIND MATCHING TAKA
    // ==============================

    const matchedIndex = matchedTableDetails.findIndex(
      (row, index) => {

        const rowId =
          `${row?.TransDtlID ?? "row"}_${index}`;

        // Already selected hai to skip
        if (selectedTakas?.[rowId]) {
          return false;
        }

        const balanceMeter =
          Number(row?.BalMeter ?? 0);

        // Grey Mtrs ke saath match
        return Math.abs(
          balanceMeter - enteredMeter
        ) < 0.01;
      }
    );

    // ==============================
    // MATCH NAHI MILA
    // ==============================

    if (matchedIndex === -1) {
      alert(
        `Grey Mtrs ${enteredMeter.toFixed(2)} ka matching Taka nahi mila.`
      );
      return;
    }

    const matchedRow =
      matchedTableDetails[matchedIndex];

    const rowId =
      `${matchedRow?.TransDtlID ?? "row"}_${matchedIndex}`;

    const balanceMeter =
      Number(matchedRow?.BalMeter ?? 0);

    // ==============================
    // SHORTAGE CALCULATION
    // ==============================

    const shortMeter =
      (balanceMeter * shortagePercent) / 100;

    const issueMeter =
      Math.max(
        balanceMeter - shortMeter,
        0
      );

    // ==============================
    // SELECT MATCHED TAKA
    // ==============================

    setSelectedTakas((prev) => ({
      ...prev,
      [rowId]: true,
    }));

    // ==============================
    // SET CALCULATED ISSUE METER
    // ==============================

    setIssueMeterValues((prev) => ({
      ...prev,
      [rowId]: issueMeter.toFixed(2),
    }));

    // IMPORTANT:
    // Grey Mtrs ko clear nahi karna
  };

  const handleSearchF6Enter = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const enteredTakaNo = String(searchF6 ?? "").trim();

    // Empty validation
    if (!enteredTakaNo) {
      alert("Please enter Taka No.");
      return;
    }

    // Taka Detail records me Taka No. match karo
    const matchedIndex = matchedTableDetails.findIndex(
      (row, index) => {
        const rowTakaNo = String(row?.JobNo ?? "").trim();

        return rowTakaNo === enteredTakaNo;
      }
    );

    // Match nahi mila
    if (matchedIndex === -1) {
      alert(
        `Taka No. ${enteredTakaNo} Taka Detail me nahi mila.`
      );
      return;
    }

    const matchedRow =
      matchedTableDetails[matchedIndex];

    const rowId =
      `${matchedRow?.TransDtlID ?? "row"}_${matchedIndex}`;

    // Already selected
    if (selectedTakas?.[rowId]) {
      alert(
        `Taka No. ${enteredTakaNo} already selected.`
      );
      return;
    }

    // Matching record CHECK
    setSelectedTakas((prev) => ({
      ...prev,
      [rowId]: true,
    }));

    // Shortage ke according Issue Meter
    const balanceMeter =
      Number(matchedRow?.BalMeter ?? 0);

    const shortagePercent =
      Number(shortStage || 0);

    const shortMeter =
      (balanceMeter * shortagePercent) / 100;

    const issueMeter =
      Math.max(
        balanceMeter - shortMeter,
        0
      );

    setIssueMeterValues((prev) => ({
      ...prev,
      [rowId]: issueMeter.toFixed(2),
    }));

    // Input clear NAHI hoga
  };



  useEffect(() => {
    if (!show) {
      setShortStage("");
      setHeaderTaka("");
      setGreyMtrs("");
      setLocation("");
    }
  }, [show]);



  return (

    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      dialogClassName="custom-xl-modal"
      contentClassName="td-modal-content"
    >
      <style>{`
        /* ── Modal Size Override ── */
        @media (min-width: 1200px) {
          .custom-xl-modal {
            max-width: 1180px !important;
            width: 100% !important;
          }
        }

        /* ── Modal Shell ── */
        .td-modal-content {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
          border: 2px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
          border-radius: 16px !important;
          overflow: hidden;
          box-shadow: 0 35px 80px rgba(0,0,0,0.5) !important;
        }

        /* ── Header ── */
        .td-header {
          background: linear-gradient(135deg,
            ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} 0%,
            ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} 100%
          );
          padding: 16px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .td-header-title {
          font-size: 16px;
          font-weight: 800;
          color: #fff;
          letter-spacing: 0.5px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .td-header-icon {
          width: 36px; height: 36px;
          border-radius: 10px;
          background: rgba(255,255,255,0.22);
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
        .td-close-btn {
          background: rgba(255,255,255,0.15);
          border: 1px solid rgba(255,255,255,0.3) !important;
          color: #fff; border-radius: 8px;
          width: 32px; height: 32px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.2s ease;
        }
        .td-close-btn:hover { background: rgba(255,255,255,0.3); transform: rotate(90deg); }

        /* ── Info Cards Grid ── */
        .td-info-section {
          background: ${isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour9 || "#2d1f0f"};
          padding: 20px 24px;
          border-bottom: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"};
        }
        .td-grid-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 12px;
        }
        .td-info-card {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#ffffff" : iscolourDark?.Colour10 || "#1a1208"};
          border: 1px solid ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour8 || "#6b4423"};
          border-radius: 10px;
          padding: 10px 14px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.02);
          transition: all 0.2s ease;
        }
        .td-info-card:hover {
          transform: translateY(-1px);
          border-color: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"};
          box-shadow: 0 6px 15px rgba(0,0,0,0.05);
        }
        .td-card-label {
          font-size: 10.5px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540"};
        }
        .td-card-value {
          font-size: 13.5px;
          font-weight: 700;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"};
        }

        /* ── Summary Bar ── */
        .td-summary-bar {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"};
          padding: 12px 24px;
          border-bottom: 1.5px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"};
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .td-taka-pill {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"};
          color: #fff;
          padding: 6px 16px;
          border-radius: 20px;
          font-weight: 800;
          font-size: 13px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }
        .td-taka-inp-container {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .td-taka-inp {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
          border: 2px solid ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          border-radius: 8px;
          padding: 6px 12px;
          font-size: 15px;
          font-weight: 800;
          outline: none;
          width: 90px;
          text-align: center;
          transition: all 0.2s ease;
        }
        .td-taka-inp:focus {
          box-shadow: 0 0 0 3px ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"}33;
        }

        /* ── Table Styling ── */
        .td-table-wrap {
          overflow-y: auto;
          max-height: 380px;
          overflow-x: auto;
        }
        .td-tbl {
          width: 100%;
          border-collapse: collapse;
          min-width: 900px;
        }
        .td-tbl thead th {
          background: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: #fff !important;
          font-size: 12px !important;
          font-weight: 800 !important;
          padding: 12px 16px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 2px solid ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          position: sticky;
          top: 0;
          z-index: 2;
        }
        .td-tbl thead th:last-child { border-right: none !important; }
        .td-tbl tbody td {
          font-size: 13.5px !important;
          padding: 9px 16px !important;
          border-right: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour8 || "#6b4423"} !important;
          border-bottom: 1px solid ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour8 || "#6b4423"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          vertical-align: middle !important;
          transition: all 0.15s ease;
        }
        .td-tbl tbody td:last-child { border-right: none !important; }
        
        /* Alternating Rows */
        .td-tbl tbody tr:nth-child(odd) td {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
        }
        .td-tbl tbody tr:nth-child(even) td {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"} !important;
        }
        .td-tbl tbody tr:hover td {
          background: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"} !important;
        }
        
        /* Selected Row Accent */
        .td-selected-row td {
          background: ${isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour2 || "#f5c99f"} !important;
          font-weight: 800 !important;
        }

        /* Checkbox styling */
        .td-rchk {
          width: 17px; height: 17px;
          accent-color: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"};
          cursor: pointer;
        }

        /* Total Row */
        .td-total-bar {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"} !important;
          display: flex;
          align-items: center;
          border-top: 2px solid ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour7 || "#7a5637"};
        }
        .td-total-cell {
          padding: 10px 16px;
          font-size: 14px;
          font-weight: 800;
          color: #fff;
          border-right: 1px solid rgba(255, 255, 255, 0.15);
        }
        .td-total-cell:last-child { border-right: none; }

        /* Forward Details Container & Badges */
        .td-fwd-container {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"};
          padding: 10px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          border-top: 1.5px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"};
          flex-wrap: wrap;
        }
        .td-fwd-title-box {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour2 || "#f5c99f"};
        }
        .td-fwd-badges {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
        }
        .td-fwd-pill {
          background: ${isdark === "light" ? iscolour?.Colour1 || "#fff" : iscolourDark?.Colour10 || "#1a1208"};
          border: 1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour8 || "#6b4423"};
          border-radius: 8px;
          padding: 4px 12px;
          font-size: 12.5px;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .td-fwd-pill-label {
          font-size: 10.5px;
          font-weight: 800;
          text-transform: uppercase;
          opacity: 0.65;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"};
        }
        .td-fwd-pill-value {
          color: ${isdark === "light" ? iscolour?.Colour10 || "#c46f20" : iscolourDark?.Colour4 || "#e19b5f"};
        }

        /* Footer */
        .td-footer {
          background: ${isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour8 || "#6b4423"};
          padding: 14px 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        .td-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13.5px;
          font-weight: 800;
          padding: 8px 22px;
          border-radius: 8px;
          border: none !important;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        .td-btn:hover {
          transform: translateY(-1.5px);
          box-shadow: 0 6px 15px rgba(0,0,0,0.25);
        }
        .td-btn-ok { background: #16a34a; color: #fff; }
        .td-btn-cancel { background: #dc2626; color: #fff; }
        .td-btn-select {
          background: rgba(255, 255, 255, 0.15);
          color: #fff;
          border: 1px solid rgba(255, 255, 255, 0.35) !important;
        }
        .td-btn-select:hover {
          background: rgba(255, 255, 255, 0.25);
        }
        .td-search-inp-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        .td-search-inp {
          background: ${isdark === "light" ? iscolour?.Colour4 || "#fef3e8" : iscolourDark?.Colour9 || "#2d1f0f"} !important;
          border: 1.5px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"} !important;
          color: ${isdark === "light" ? iscolour?.Colour11 || "#8b5a2b" : iscolourDark?.Colour1 || "#fcefd9"} !important;
          border-radius: 8px;
          padding: 6px 12px 6px 34px;
          font-size: 13px;
          font-weight: 700;
          outline: none;
          width: 180px;
          transition: all 0.2s ease;
        }
        .td-search-inp::placeholder {
          color: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540"};
        }
        .td-search-inp:focus {
          border-color: ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"} !important;
          box-shadow: 0 0 0 3px ${isdark === "light" ? iscolour?.Colour8 || "#D78C4D" : iscolourDark?.Colour4 || "#e19b5f"}33;
        }
          .td-issue-meter-input {
  width: 110px;
  padding: 6px 10px;
  border: 1.5px solid #d78c4d;
  border-radius: 7px;
  outline: none;
  text-align: right;
  font-size: 13px;
  font-weight: 700;
  background: #fff;
  color: #8b5a2b;
}

.td-issue-meter-input:focus {
  border-color: #a66b35;
  box-shadow: 0 0 0 3px rgba(215, 140, 77, 0.18);
}

/* =====================================================
   TAKA DETAIL HEADER EXTRA FIELDS
===================================================== */

.td-extra-fields-row {
  width: 100%;

  display: grid;

  /*
     Same compact style as existing
     Taka Detail header
  */
  grid-template-columns:
    minmax(140px, 1fr)
    minmax(100px, 0.75fr)
    minmax(140px, 1fr)
    minmax(180px, 1.2fr);

  align-items: center;

  gap: 10px;

  margin-top: 6px;
  padding-top: 6px;

  border-top: 1px solid rgba(255, 255, 255, 0.25);

  box-sizing: border-box;
}


/* Individual field */

.td-extra-field {
  width: 100%;
  min-width: 0;

  display: flex;
  align-items: center;

  gap: 5px;

  box-sizing: border-box;
}


/* Label */

.td-extra-label {
  flex: 0 0 auto;

  margin: 0;

  font-size: 15px;
  font-weight: 800;

  white-space: nowrap;

     color: ${isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540"};
}


/* Input */

.td-extra-input,
.td-extra-select {
  width: 100%;
  min-width: 0;

  height: 27px;

  padding: 2px 6px;

  box-sizing: border-box;

  border: 1px solid
    ${isdark === "light"
          ? iscolour?.Colour6 || "#e6a571"
          : iscolourDark?.Colour7 || "#7a5637"
        };

  border-radius: 3px;

  outline: none;

  background:
    ${isdark === "light"
          ? iscolour?.Colour1 || "#ffffff"
          : iscolourDark?.Colour10 || "#1a1208"
        };

  color:
    ${isdark === "light"
          ? iscolour?.Colour11 || "#8b5a2b"
          : iscolourDark?.Colour1 || "#fcefd9"
        };

  font-size: 11px;
  font-weight: 700;
}


/* Number fields */

.td-extra-input {
  max-width: 85px;

  text-align: right;
}


/* Location */

.td-extra-select {
  max-width: 170px;
}


/* Placeholder */

.td-extra-input::placeholder,
.td-extra-select::placeholder {
  color:
    ${isdark === "light"
          ? iscolour?.Colour7 || "#d7b08a"
          : iscolourDark?.Colour5 || "#b07540"
        };

  opacity: 0.8;
}


/* Focus */

.td-extra-input:focus,
.td-extra-select:focus {

  border-color:
    ${isdark === "light"
          ? iscolour?.Colour8 || "#D78C4D"
          : iscolourDark?.Colour4 || "#e19b5f"
        };

  box-shadow:
    0 0 0 2px
    ${isdark === "light"
          ? iscolour?.Colour8 || "#D78C4D"
          : iscolourDark?.Colour4 || "#e19b5f"
        }33;
}


/* =====================================================
   TABLET
===================================================== */

@media (max-width: 1000px) {

  .td-extra-fields-row {

    grid-template-columns:
      repeat(2, minmax(180px, 1fr));

    gap: 7px;
  }

  .td-extra-input,
  .td-extra-select {
    max-width: none;
  }

}


/* =====================================================
   MOBILE
===================================================== */

@media (max-width: 576px) {

  .td-extra-fields-row {

    grid-template-columns: 1fr;

    gap: 6px;

    margin-top: 7px;

    padding-top: 6px;
  }


  .td-extra-field {

    width: 100%;

    justify-content: space-between;
  }


  .td-extra-label {

    min-width: 100px;

    font-size: 11px;
  }


  .td-extra-input,
  .td-extra-select {

    flex: 1;

    max-width: none;

    height: 28px;
  }

}


/* =====================================================
   SMALL MOBILE
===================================================== */

@media (max-width: 380px) {

  .td-extra-label {
    min-width: 88px;
    font-size: 10px;
  }

  .td-extra-input,
  .td-extra-select {
    font-size: 11px;
  }

}
  .td-btn-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
 
`}</style>

      {/* ── HEADER ── */}
      <div className="td-header">
        <div className="td-header-title">
          <div className="td-header-icon">
            <FileText size={18} color="#fff" />
          </div>

          Taka Detail Overview

        </div>
        <button className="td-close-btn" onClick={onHide}>
          <X size={16} />
        </button>
      </div>

      {/* ── INFO CARDS SECTION ── */}
      {/* ── INFO CARDS SECTION ── */}
      <div className="td-info-section">

        <div className="td-grid-container">

          <div className="td-info-card">
            <span className="td-card-label">Lot No.</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.LotNo ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Inward Date</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.InwDate
                ? new Date(
                  matchedInfoDetails[0].InwDate
                ).toLocaleDateString("en-GB")
                : "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Inward Sr. No.</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.InwSrNo ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">A/C Name</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.AcName ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Party</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.ShortACName ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Group Name</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.GroupName ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Quality Type</span>
            <span className="td-card-value">
              {matchedInfoDetails[0]?.QualityType ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Issue Taka</span>
            <span className="td-card-value">
              {issueTaka ?? "-"}
            </span>
          </div>

          <div className="td-info-card">
            <span className="td-card-label">Issue Meter</span>
            <span className="td-card-value">
              {takaMeter ?? "-"}
            </span>
          </div>

        </div>


        {/* =================================================
      HEADER INPUTS
  ================================================= */}

        <div className="td-extra-fields-row">

          {/* Shortage */}
          {(showShortage && showShortageColumns) && (
            <div className="td-extra-field">

              <label className="td-extra-label">
                Shortage (%):
              </label>

              <input
                type="number"
                step="0.01"
                value={shortStage}
                onChange={(e) => {
                  const value = e.target.value;
                  if (Number(value) > 100) {
                    setShortStage("100");
                    return;
                  }



                  setShortStage(value);

                  const shortagePercent = Number(value || 0);

                  setIssueMeterValues((prev) => {
                    const updated = { ...prev };

                    Object.keys(selectedTakas || {}).forEach((rowId) => {
                      if (!selectedTakas[rowId]) return;

                      const rowIndex = matchedTableDetails.findIndex(
                        (row, index) =>
                          `${row?.TransDtlID ?? "row"}_${index}` === rowId
                      );

                      if (rowIndex === -1) return;

                      const row = matchedTableDetails[rowIndex];

                      const balanceMeter = Number(row?.BalMeter ?? 0);

                      const issueMeter = calculateIssueMeterByShortage(
                        balanceMeter,
                        shortagePercent
                      );

                      updated[rowId] = issueMeter.toFixed(2);
                    });

                    return updated;
                  });
                }}
                className="td-extra-input"
                placeholder="0.00"
              />

            </div>
          )}


          {/* Taka */}
          {showTaka && (
            <div className="td-extra-field">

              <label className="td-extra-label">
                Taka:
              </label>

              <input
                type="number"
                min="0"
                value={headerTaka}
                onChange={(e) => setHeaderTaka(e.target.value)}
                onKeyDown={handleHeaderTakaEnter}
                className="td-extra-input"
                placeholder="0"
              />
            </div>
          )}


          {/* Grey Mtrs */}
          {showGreyMtr && (
            <div className="td-extra-field">

              <label className="td-extra-label">
                Grey Mtrs:
              </label>

              <input
                type="number"
                step="0.01"
                min="0"
                value={greyMtrs}
                onChange={(e) => setGreyMtrs(e.target.value)}
                onKeyDown={handleGreyMtrsEnter}
                className="td-extra-input"
                placeholder="0.00"
              />

            </div>
          )}

          {showLocation && (
            <div className="td-extra-field">
              <label className="td-extra-label">
                Location:
              </label>

              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="td-extra-select"
              >
                <option value="">Select Location</option>

                {TransFiltersdata?.Location?.map((item, index) => (
                  <option
                    key={item?.LocationID ?? index}
                    value={item?.LocationID ?? item?.Location}
                  >
                    {item?.LocationName ?? item?.Location}
                  </option>
                ))}
              </select>
            </div>
          )}

        </div>

      </div>

      {/* ── SUMMARY BAR ── */}

      <div className="td-summary-bar">
        <div className="td-taka-pill">
          Total Taka : &nbsp;<span style={{ fontSize: "15px", color: isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour2 || "#f5c99f" }}>{matchedTableDetails.length}</span>
        </div>
        {/* <div className="td-taka-inp-container">
          <span style={{ fontSize: "14px", fontWeight: "800", color: headingCol }}>Taka Quantity:</span>
          <input
            type="number"
            value={takaQty}
            onChange={(e) => setTakaQty(e.target.value)}
            className="td-taka-inp"
            placeholder="0"
          />
        </div> */}
      </div>

      {/* ── TABLE ── */}
      <div className="td-table-wrap">
        <table className="td-tbl">
          <thead>
            <tr>
              <th
                className="text-center"
                style={{
                  width: "45px",
                  background: "transparent"
                }}
              >
                Select
              </th>

              <th style={{ textAlign: "right", width: "120px" }}>
                Taka No.
              </th>

              <th style={{ textAlign: "right" }}>
                Stage (Balance)
              </th>

              <th style={{ textAlign: "right" }}>
                Issue (Meter)
              </th>
              {showShortageColumns && (
                <th style={{ textAlign: "right" }}>
                  Short (Meter)
                </th>
              )}

              {showShortageColumns && (
                <th style={{ textAlign: "right" }}>
                  Short (%)
                </th>
              )}

              {showShortageColumns && (
                <th style={{ textAlign: "right" }}>
                  Balance Meter
                </th>
              )}

              <th style={{ textAlign: "right" }}>
                Inward Qty
              </th>
            </tr>
          </thead>

          <tbody>
            {matchedTableDetails
              .filter(
                (row) =>
                  takaSearch === "" ||
                  String(
                    row?.TakaNo ??
                    row?.TakaCount ??
                    ""
                  ).includes(takaSearch)
              )
              .map((row, index) => {

                const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

                const balanceMeter = Number(row?.BalMeter ?? 0);

                const issueMeterValue = issueMeterValues[rowId];

                const issueMeter =
                  issueMeterValue !== undefined &&
                    issueMeterValue !== ""
                    ? Number(issueMeterValue)
                    : 0;

                // Issue Meter nahi dala hai to Short = 0
                const hasIssueMeter =
                  issueMeterValue !== undefined &&
                  issueMeterValue !== "" &&
                  Number.isFinite(Number(issueMeterValue));

                const shortMeter =
                  isAutoShortage && hasIssueMeter
                    ? Math.max(balanceMeter - issueMeter, 0)
                    : 0;

                const shortPercent =
                  isAutoShortage && hasIssueMeter && balanceMeter > 0
                    ? (shortMeter / balanceMeter) * 100
                    : 0;

                const finalBalanceMeter = selectedTakas[rowId]
                  ? balanceMeter - issueMeter - shortMeter
                  : balanceMeter;

                return (
                  <tr
                    key={rowId}
                    className={
                      selectedTakas[rowId]
                        ? "td-selected-row"
                        : ""
                    }
                  >

                    {/* Checkbox */}
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        className="td-rchk"
                        checked={!!selectedTakas[rowId]}
                        onChange={(e) => {
                          const checked = e.target.checked;

                          setSelectedTakas((prev) => ({
                            ...prev,
                            [rowId]: checked
                          }));

                          setIssueMeterValues((prev) => {
                            const updated = { ...prev };

                            if (checked) {
                              const balanceMeter = Number(row?.BalMeter ?? 0);

                              const shortagePercent = Number(shortStage || 0);

                              const issueMeter = calculateIssueMeterByShortage(
                                balanceMeter,
                                shortagePercent
                              );

                              updated[rowId] = issueMeter.toFixed(2);
                            } else {
                              delete updated[rowId];
                            }

                            return updated;
                          });
                        }}
                      />
                    </td>

                    {/* Taka No */}
                    <td style={{ textAlign: "right" }}>
                      {row?.JobNo ?? "-"}
                    </td>

                    {/* Stage Balance */}
                    <td style={{ textAlign: "right" }}>
                      {Number(row?.BalMeter ?? 0).toFixed(2)}
                    </td>

                    {/* Issue Meter */}
                    <td style={{ textAlign: "right" }}>
                      <input
                        type="number"
                        step="0.01"
                        value={issueMeterValues[rowId] ?? ""}
                        disabled={!isIssueMeterEditable}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Issue Meter value set
                          setIssueMeterValues((prev) => ({
                            ...prev,
                            [rowId]: value,
                          }));

                          // Issue Meter me value hai to row automatically select
                          setSelectedTakas((prev) => ({
                            ...prev,
                            [rowId]: value !== "" && Number(value) > 0,
                          }));
                        }}
                        onBlur={(e) => {
                          if (!isIssueMeterEditable) return;

                          const value = e.target.value;

                          if (value !== "") {
                            setIssueMeterValues((prev) => ({
                              ...prev,
                              [rowId]: Number(value).toFixed(2)
                            }));
                          }
                        }}
                        className="td-issue-meter-input"
                      />
                    </td>
                    {/* Short Meter */}
                    {showShortageColumns && (
                      <td style={{ textAlign: "right" }}>
                        {shortMeter.toFixed(2)}
                      </td>
                    )}

                    {/* Short % */}
                    {showShortageColumns && (
                      <td style={{ textAlign: "right" }}>
                        {shortPercent.toFixed(2)}%
                      </td>
                    )}

                    {/* Balance Meter */}
                    {showShortageColumns && (
                      <td style={{ textAlign: "right" }}>
                        {finalBalanceMeter.toFixed(2)}
                      </td>
                    )}

                    {/* Inward Qty */}
                    <td style={{ textAlign: "right" }}>
                      {Number(row?.InwardQty ?? 0).toFixed(2)}
                    </td>

                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      {/* ── TOTAL BAR ── */}
      <div className="td-total-bar">

        {/* Checkbox column */}
        <div
          className="td-total-cell"
          style={{
            width: "60px",
            flexShrink: 0
          }}
        />

        {/* Taka Count / Rows */}
        <div
          className="td-total-cell"
          style={{
            textAlign: "right",
            width: "120px",
            flexShrink: 0
          }}
        >

          {matchedTableDetails.length}

        </div>

        {/* Stage Balance Total */}
        <div
          className="td-total-cell"
          style={{
            textAlign: "right",
            flex: 1
          }}
        >
          {matchedTableDetails
            .reduce(
              (total, row) =>
                total + Number(row?.Balance ?? 0),
              0
            )
            .toFixed(2)}
        </div>

        {/* Issue Meter Total */}
        <div
          className="td-total-cell"
          style={{
            textAlign: "right",
            flex: 1,
            color:
              isdark === "light"
                ? iscolour?.Colour5 || "#fde9d3"
                : iscolourDark?.Colour2 || "#f5c99f"
          }}
        >
          {matchedTableDetails
            .reduce(
              (total, row) =>
                total + Number(row?.Qty ?? 0),
              0
            )
            .toFixed(2)}
        </div>

        {/* Inward Qty Total */}
        <div
          className="td-total-cell"
          style={{
            textAlign: "right",
            flex: 1
          }}
        >
          {matchedTableDetails
            .reduce(
              (total, row) =>
                total + Number(row?.Qty ?? 0),
              0
            )
            .toFixed(2)}
        </div>

      </div>
      {/* ── FORWARD DETAILS STRIP ── */}
      <div className="td-fwd-container">
        <div className="td-fwd-title-box">
          <Info size={15} />
          <span>Forward Details</span>
        </div>
        <div className="td-fwd-badges">
          <div className="td-fwd-pill">
            <span className="td-fwd-pill-label">Stg:</span>
            <span className="td-fwd-pill-value">DELIVERY</span>
          </div>
          <div className="td-fwd-pill">
            <span className="td-fwd-pill-label">Sr:</span>
            <span className="td-fwd-pill-value">G001368</span>
          </div>
          <div className="td-fwd-pill">
            <span className="td-fwd-pill-label">Dt:</span>
            <span className="td-fwd-pill-value">08-05-26</span>
          </div>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <div className="td-footer">
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>

          <button
            className="td-btn td-btn-ok"
            disabled={
              Object.keys(selectedTakas || {}).filter(
                (id) => selectedTakas[id]
              ).length === 0
            }
            onClick={() => {
              const selectedCount = Object.keys(
                selectedTakas || {}
              ).filter((id) => selectedTakas[id]).length;

              if (selectedCount === 0) {
                toast.warning("Please select at least one Taka");
                return;
              }

              toast.success("Taka detail saved");



              if (onComplete) {
                onComplete({
                  selectedTakas,
                  issueMeterValues,

                  // HEADER FIELDS
                  shortStage,
                  headerTaka,
                  greyMtrs,
                  location
                });
              } else {
                onHide();
              }
            }}
          >
            ✔ OK
          </button>


          <button
            className="td-btn td-btn-cancel"
            onClick={onHide}
          >
            <X size={13} /> Cancel
          </button>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div className="td-search-inp-wrapper">
            <Search
              size={14}
              style={{
                position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)",
                color: isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540",
                pointerEvents: "none"
              }}
            />

            {/* NEW Search F6 */}
            <input
              type="text"
              value={searchF6}
              onChange={(e) => setSearchF6(e.target.value)}
              onKeyDown={handleSearchF6Enter}
              placeholder="input taka No "
              className="td-search-inp"
            />
          </div>

          <button
            className="td-btn td-btn-select"
            disabled={isIssueMeterEditbutton}
            onClick={() => {
              const filteredRows = matchedTableDetails.filter(
                (row) =>
                  takaSearch === "" ||
                  String(
                    row?.TakaNo ?? row?.TakaCount ?? ""
                  ).includes(takaSearch)
              );

              // Check whether all visible records are already selected
              const allSelected =
                filteredRows.length > 0 &&
                filteredRows.every((row, index) => {
                  const rowId = `${row?.TransDtlID ?? "row"}_${index}`;
                  return !!selectedTakas[rowId];
                });

              // =========================
              // SELECT / DESELECT ALL TAKA
              // =========================
              setSelectedTakas((prev) => {
                const updated = { ...prev };

                filteredRows.forEach((row, index) => {
                  const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

                  if (allSelected) {
                    // Deselect
                    delete updated[rowId];
                  } else {
                    // Select
                    updated[rowId] = true;
                  }
                });

                return updated;
              });

              // =========================
              // SELECT / DESELECT ALL METER
              // =========================
              setIssueMeterValues((prev) => {
                const updated = { ...prev };

                filteredRows.forEach((row, index) => {
                  const rowId = `${row?.TransDtlID ?? "row"}_${index}`;

                  if (allSelected) {
                    // Deselect => remove Issue Meter
                    delete updated[rowId];
                  } else {

                    // Select => Shortage (%) ke according Issue Meter calculate
                    const balanceMeter = Number(row?.BalMeter ?? 0);
                    const shortagePercent = Number(shortStage || 0);

                    const issueMeter = calculateIssueMeterByShortage(
                      balanceMeter,
                      shortagePercent
                    );

                    updated[rowId] = issueMeter.toFixed(2);
                  }
                });

                return updated;
              });

              toast.info(
                allSelected
                  ? "All Taka Deselected"
                  : "All Taka Selected"
              );
            }}
          >
            {matchedTableDetails.length > 0 &&
              matchedTableDetails
                .filter(
                  (row) =>
                    takaSearch === "" ||
                    String(
                      row?.TakaNo ?? row?.TakaCount ?? ""
                    ).includes(takaSearch)
                )
                .every((row, index) => {
                  const rowId = `${row?.TransDtlID ?? "row"}_${index}`;
                  return !!selectedTakas[rowId];
                })
              ? "Deselect All Taka"
              : "Select All Taka"}
          </button>


        </div>
      </div>
    </Modal>
  );
};

export default TakaDetailModal;
